// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class JournalTitleService {
   $timeout: any
   jt: any
   results: any
   constructor(results: any, $timeout: any) {
      this.update = this.update.bind(this)
      this.clearJournalTitle = this.clearJournalTitle.bind(this)
      this.results = results
      this.$timeout = $timeout
      this.jt = {journalTitle: null, hidden: true}
      this.results.on('new', this.update)
   }

   update() {
      const journalTitle = this.results.data.search.recommendations.journal_title || {}
      this.clearJournalTitle()
      if (journalTitle && journalTitle.count) {
         return this.$timeout(() => {
            this.jt.journalTitle = journalTitle.title.replace(/[:,]/g, '')
            return this.jt.hidden = false
         }
         , 200)
      }
   }

   clearJournalTitle() {
      this.jt.journalTitle = null
      return this.jt.hidden = true
   }
}


angular.module('summonApp.services')
   .service('journalTitleService', ['dataService', '$timeout', JournalTitleService])
